// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingPage_loadingContainer__12pVt","loading":"LoadingPage_loading__3SyVW"};